import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const SAVE_ADVANCE = SERVER_URI + '/party/create_advance';
const GET_ADVANCE_DATA = SERVER_URI + '/party/getAdvance/';
const UPDATE_ADVANCE_DATA = SERVER_URI + '/party/updateAdvance/';
const CHANGE_ADVANCE_STATUS = SERVER_URI + '/party/changeStatus/';


export default {

    saveAdvance: async function (payload) {
        return apiPost(SAVE_ADVANCE, payload)
    },
    getAdvancdData: async function (id) {
        return apiGet(GET_ADVANCE_DATA +id);
    },
    updateAdvanceData: async function (id, payload) {
        return apiPut(UPDATE_ADVANCE_DATA + id, payload)
    },
    changeAdvanceStatus: async function (id) {
        return apiGet(CHANGE_ADVANCE_STATUS + id);
    },
};